import React from 'react';

import GrCardV2Skeleton from './GrCardV2Skeleton';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Skeleton } from '../Skeleton';

const SpecialityContentSliderSkeleton = ({ isContentPage = false }) => {
  return (
    <div className="w-100 cmnLandingSlideRow">
      <div className="d-flex justify-content-between align-items-baseline mb-3">
        <h2 className="text-black fs-2 fw-semibold">
          <Skeleton width={150} height={40} variant="text" />
        </h2>
        <a href="javascript:void(0)" className="text-primary rippleEffect fs-4 fw-medium">
          <Skeleton width={30} height={15} variant="text" />
        </a>
      </div>
      <div className="cmnLndngRowSlidePrrnt">
        <Swiper
          className="cmnLndngRowSlide"
          spaceBetween={24}
          slidesPerView={3}
          loop={false}
          breakpoints={{
            1: {
              slidesPerView: 1,
              spaceBetween: 10
            },
            640: {
              slidesPerView: 1,
              spaceBetween: 15
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 22
            },
            992: {
              slidesPerView: isContentPage ? 2 : 3,
              spaceBetween: 24
            },
            1400: {
              slidesPerView: isContentPage ? 3 : 4,
              spaceBetween: 26
            }
          }}
        >
          <SwiperSlide>
            {/* <GrCardV2 data={_training} /> */}
            <GrCardV2Skeleton />
          </SwiperSlide>
          <SwiperSlide>
            {/* <GrCardV2 data={_training} /> */}
            <GrCardV2Skeleton />
          </SwiperSlide>
          <SwiperSlide>
            {/* <GrCardV2 data={_training} /> */}
            <GrCardV2Skeleton />
          </SwiperSlide>
          <SwiperSlide>
            {/* <GrCardV2 data={_training} /> */}
            <GrCardV2Skeleton />
          </SwiperSlide>
          <SwiperSlide>
            {/* <GrCardV2 data={_training} /> */}
            <GrCardV2Skeleton />
          </SwiperSlide>
          <SwiperSlide>
            {/* <GrCardV2 data={_training} /> */}
            <GrCardV2Skeleton />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default SpecialityContentSliderSkeleton;
